<br />
<div class="col-md-8 offset-md-2">

    <!--<mat-horizontal-stepper>-->

    <!--<mat-step>-->
    <form class="text-center" onkeypress="return event.keyCode != 13;">
        <mat-card appearance="outlined">
            <strong>Nuevo mandato</strong>
        </mat-card>

        <!-- ------------------------ STEP 1 ------------------------------------- -->


        <mat-card appearance="outlined">

            <div class="row">
                <div class="col-md-6">
                    <app-input inputType="text" placeholder="Referencia" name="mandate.mandateRef"
                        [isRequired]="true" [(ngModel)]="mandate.mandateRef"></app-input>

                    <br />

                    <app-input inputType="text" placeholder="Domiciliación" name="mandate.domiciliationRef"
                        [isRequired]="true" [(ngModel)]="mandate.domiciliationRef"></app-input>

                    <br />

                    <app-input inputType="text" placeholder="Nombre acreedor" name="mandate.creditorName"
                        [isRequired]="true" [(ngModel)]="mandate.creditorName"></app-input>

                    <br />

                    <app-input inputType="text" placeholder="Dirección acreedor" name="mandate.creditorAddress"
                        [isRequired]="true" [(ngModel)]="mandate.creditorAddress"></app-input>

                    <br />

                    <app-input inputType="text" placeholder="Código postal acreedor" name="mandate.creditorPostalCode"
                        [isRequired]="true" [(ngModel)]="mandate.creditorPostalCode"></app-input>

                    <br />

                    <app-input inputType="text" placeholder="Población acreedor" name="mandate.creditorLocation"
                        [isRequired]="true" [(ngModel)]="mandate.creditorLocation"></app-input>

                    <br />

                    <app-input inputType="text" placeholder="Provincia acreedor" name="mandate.creditorState"
                        [isRequired]="true" [(ngModel)]="mandate.creditorState"></app-input>

                    <br />

                    <app-input inputType="text" placeholder="País acreedor" name="mandate.creditorCountry"
                        [isRequired]="true" [(ngModel)]="mandate.creditorCountry"></app-input>

                    <br />

                    <mat-form-field class="text-center mt-2">
                        <input matInput [matDatepicker]="date" placeholder="Fecha" name="mandate.createDate" weekStart=1
                            [(ngModel)]="mandate.createDate" required>
                        <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
                        <mat-datepicker #date></mat-datepicker>
                    </mat-form-field>

                    <br />

                </div>

                <div class="col-md-6">

                    <app-input inputType="text" placeholder="Nombre deudor" name="mandate.debtorName"
                        [isRequired]="true" [(ngModel)]="mandate.debtorName"></app-input>

                    <br />

                    <app-input inputType="text" placeholder="Dirección deudor" name="mandate.debtorAddress"
                        [isRequired]="true" [(ngModel)]="mandate.debtorAddress"></app-input>

                    <br />

                    <app-input inputType="text" placeholder="Código postal deudor" name="mandate.debtorPostalCode"
                        [isRequired]="true" [(ngModel)]="mandate.debtorPostalCode"></app-input>

                    <br />

                    <app-input inputType="text" placeholder="Población deudor" name="mandate.debtorLocation"
                        [isRequired]="true" [(ngModel)]="mandate.debtorLocation"></app-input>

                    <br />

                    <app-input inputType="text" placeholder="Provincia deudor" name="mandate.debtorState"
                        [isRequired]="true" [(ngModel)]="mandate.debtorState"></app-input>

                    <br />

                    <app-input inputType="text" placeholder="País deudor" name="mandate.debtorCountry"
                        [isRequired]="true" [(ngModel)]="mandate.debtorCountry"></app-input>

                    <br />

                    <app-input inputType="text" placeholder="BIC" name="mandate.debtorBic"
                        [isRequired]="true" [(ngModel)]="mandate.debtorBic"></app-input>

                    <br />
                    <app-input inputType="text" placeholder="IBAN" name="mandate.debtorIban"
                        [isRequired]="true" [(ngModel)]="mandate.debtorIban"></app-input>

                    <br />

                    <mat-form-field class="form-field text-center mt-2">
                        <input matInput [(ngModel)]="mandate.typePay" value="mandate.typePay" placeholder="Tipo de pago"
                            [matAutocomplete]="autoT" [formControl]="payMethodCtrl" class="text-center" required>
                        <mat-autocomplete #autoT="matAutocomplete" class="type-pay-mat-autocomplete" classList="type-pay-mat-autocomplete">
                            <mat-option *ngFor="let method of filteredPayMethod | async; trackBy: trackByIndex" [value]="method">
                                <span>{{ method }}</span>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <br />

                </div>
            </div>

        </mat-card>

        <div class="mt-4">
            <button mat-stroked-button (click)="save(mandate)">
                <mat-icon>save</mat-icon>
                Guardar
            </button>
        </div>
    </form>
    <br />
    <p class="text-center">
        <strong>Los campos marcados con *, son obligatorios</strong>
    </p>
    <p class="text-center">
        <strong>*Consejo:</strong> Puedes usar el tabulador para ir cambiando de campo
    </p>
</div>